import * as React from "react";
import Btn from "@warda/library-ui/core/Btn";
import TextLoading from "@warda/library-ui/core/TextLoading";
import { getTheme } from "@warda/library-ui/theme";
import { ACT_VPORT } from "../reducer";
import { useContextDispatchViewport } from "../SharePage";
const ViewLoadMore = ({ color = getTheme().colors.theme1, className, style, type, moreLoading, moreFailed, }) => {
    const dispatchViewport = useContextDispatchViewport();
    const tooltip = moreFailed
        ? "There are newly added media. Refresh the page to load the new content."
        : "Click to load more results";
    const onLoadClik = React.useCallback(() => {
        dispatchViewport({ type: ACT_VPORT.INIT_MORE_STARTED, moreType: type });
    }, [dispatchViewport, type]);
    return (React.createElement("div", { className: className, style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: `1px solid ${color}`,
            boxSizing: "border-box",
            height: 32,
            width: 120,
            borderRadius: getTheme().borderRadius,
            backgroundColor: getTheme().colors.background,
            ...style,
        } }, moreLoading ? (React.createElement(TextLoading, { color: color })) : (React.createElement(Btn, { style: { margin: 0, flex: 1, textAlign: "center" }, color: color, label: "LOAD MORE", labelStyle: { color }, tooltip: tooltip, onClick: onLoadClik }))));
};
export default ViewLoadMore;
